const Check = ({ email }) => {
	return (
		<div className="terms" style={{ marginTop: "7.5px", height: "125px" }}>
			<p>
				<span>
					Thank you for your sponsorship commitment for the 2027 Valero Benefit
					for Children. Your invoice will be generated and sent to{" "}
					<strong>{email}</strong>, please remember to check your spam folder if
					not received in a few minutes. You can then print the Sponsorship
					Invoice and submit payment by check or ACH / wire transfer.
				</span>
			</p>

			<p>
				<span>
					Payment by credit or debit card is also available from your dashboard
					after your registration is complete.
				</span>
			</p>
		</div>
	);
};

export default Check;
